import { Link } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import MobileEmergencyBar from '../../components/MobileEmergencyBar';
import Icon from '../../components/AppIcon';

const RoadMarkings = () => {
  const included = [
    'Car park bay marking and numbering',
    'Road line painting and directional arrows',
    'Pedestrian crossing and safety zone markings',
    'No-parking and reserved bay stencilling',
    'Custom signage board design and installation',
    'Reflective and high-visibility paint applications',
  ];

  const capabilities = [
    { icon: 'MapPin', title: 'Precision Layout Planning', desc: 'We plan and measure every marking to maximise space efficiency and traffic flow on your site.' },
    { icon: 'Sun', title: 'Durable Materials', desc: 'We use road-grade thermoplastic and reflective paints built to withstand heavy traffic and weather.' },
    { icon: 'PenTool', title: 'Custom Signage Design', desc: 'Our team designs and fabricates signage boards that meet your branding and compliance requirements.' },
    { icon: 'ShieldCheck', title: 'Safety Compliance', desc: 'All markings and signage conform to South African road safety and municipal standards.' },
  ];

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      <main className="flex-1 pt-16">
        {/* Hero */}
        <section className="bg-gradient-to-br from-primary/10 to-accent/10 py-16 md:py-24">
          <div className="max-w-5xl mx-auto px-4 lg:px-8 text-center">
            <div className="inline-flex items-center gap-2 bg-accent/20 text-accent px-4 py-2 rounded-full text-sm font-semibold mb-6">
              <Icon name="MapPin" size={16} />
              <span>Markings & Signage</span>
            </div>
            <h1 className="text-3xl md:text-5xl font-bold text-foreground mb-6">Road Markings & Signage Boards</h1>
            <p className="text-lg md:text-xl text-muted-foreground max-w-3xl mx-auto mb-8">
              Improve safety, traffic flow, and compliance on your property with Meriodine's professional road marking and signage service. From car park bays to directional arrows and custom signage boards, we deliver clear, durable results that stand the test of time.
            </p>
            <Link to="/contact">
              <button className="inline-flex items-center gap-2 bg-primary hover:bg-primary/90 text-primary-foreground px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300">
                <Icon name="FileText" size={20} />
                Request a Quote
              </button>
            </Link>
          </div>
        </section>

        {/* What's Included */}
        <section className="py-16 bg-background">
          <div className="max-w-5xl mx-auto px-4 lg:px-8">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-8 text-center">What's Included</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {included?.map((item, i) => (
                <div key={i} className="flex items-start gap-3 bg-card border border-border rounded-lg p-4">
                  <Icon name="CheckCircle" size={20} color="var(--color-success)" className="mt-0.5 shrink-0" />
                  <span className="text-foreground">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Key Capabilities */}
        <section className="py-16 bg-muted/30">
          <div className="max-w-5xl mx-auto px-4 lg:px-8">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-8 text-center">Key Capabilities</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {capabilities?.map((cap, i) => (
                <div key={i} className="flex gap-4 bg-card border border-border rounded-xl p-6">
                  <div className="bg-accent/10 p-3 rounded-lg h-fit">
                    <Icon name={cap?.icon} size={24} color="var(--color-accent)" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-foreground mb-1">{cap?.title}</h3>
                    <p className="text-sm text-muted-foreground">{cap?.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-16 bg-primary text-primary-foreground">
          <div className="max-w-3xl mx-auto px-4 text-center">
            <h2 className="text-2xl md:text-3xl font-bold mb-4">Get Clear, Compliant Markings on Your Site</h2>
            <p className="text-primary-foreground/80 mb-8">Request a quote and our team will assess your site and provide a detailed proposal.</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/contact">
                <button className="inline-flex items-center gap-2 bg-white text-primary hover:bg-white/90 px-8 py-4 rounded-lg font-semibold transition-all duration-300">
                  <Icon name="FileText" size={20} />
                  Request a Quote
                </button>
              </Link>
              <Link to="/schedule-service">
                <button className="inline-flex items-center gap-2 border-2 border-white text-white hover:bg-white/10 px-8 py-4 rounded-lg font-semibold transition-all duration-300">
                  <Icon name="CalendarCheck" size={20} />
                  Schedule a Site Visit
                </button>
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <MobileEmergencyBar />
    </div>
  );
};

export default RoadMarkings;
